import { configureStore } from "@reduxjs/toolkit";
import appReducer from "./slices/appSlice";
import adminReducer from "./slices/adminSlice";

export const store = configureStore({
    reducer: {
        app: appReducer,
        admin: adminReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export default store;
